import React, { PropsWithChildren } from 'react';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import { useTheme } from 'styled-components';

const isBrowser = typeof window !== 'undefined';

const DesignSystemThemeProviderLegacy: React.FC<PropsWithChildren> = ({ children }) => {
  const { iconBasePath } = useTheme() as { iconBasePath?: string };
  const resolvedIconBasePath =
    iconBasePath && !/^(\/|https?:\/\/)/.test(iconBasePath) ? `/${iconBasePath}` : iconBasePath;

  if (isBrowser) {
    return (
      <ThemeProvider
        theme={{
          name: 'light',
          ...(resolvedIconBasePath ? { iconBasePath: resolvedIconBasePath } : {}),
        }}
      >
        {children}
      </ThemeProvider>
    );
  }
  return <>{children}</>;
};

export default DesignSystemThemeProviderLegacy;
